export interface IWeek {
  days: string[];
  name: string;
}
export interface ITrainingRegistration {
  id: number;
  courseid: number;
  name: string;
}
export interface ICourse {
  id: number;
  courseinfoid: number;
  date: string;
  name: string;
  start_time: string;
  end_time: string;
  day_of_week: string;
  maximum_registrations: number;
  current_registrations: number;
  registrations: ITrainingRegistration[];
}
export interface IExcludedDay {
  id: number;
  date: string;
  reason: string;
}
export interface ICourseData {
  is_registration_allowed: boolean;
  course: ICourse;
  exclusion: IExcludedDay;
}
export interface ICourseRow {
  name: string;
  courses: {[id: string]: ICourseData};
}
export interface ICourseGroup {
  name: string;
  courseRows: ICourseRow[];
  header_color: string;
  body_color: string;
  header_font_color: string;
}
export interface IData {
  weeks: IWeek[];
  courseGroups: ICourseGroup[];
}
export interface INotification {
  id: number;
  title: string;
  body: string;
  enabled: boolean;
}
export interface IScheduleResponse {
  status: "success" | "fail";
  data: IData;
  notification?: INotification;
}

export interface IEvent {
  id: number;
  name: string;
  title: string;
  subtitle: string;
  description: string;
}

export interface IEventAppointment {
  id: number;
  maximumRegistrations: number;
  currentRegistrations?: number;
  text: string;
  hasAppointment: true;
  rowid: number;
  colid: number;
  tableid: number;
}
export interface INoAppointment {
  hasAppointment: false;
}

export interface IEventTable {
  id: number;
  eventid: number;
  heading: string;
  backgroundColor: string;
  foregroundColor: string;
  showHeading: boolean;
  tableIndex: number;
}

export interface IEventRow {
  id: number;
  eventRegistrationTableId: number;
  backgroundColor: string;
  textColor: string;
  rowIndex: number;
  rowHeader: string;
}

export interface IEventColumn {
  id: number;
  eventRegistrationTableId: number;
  backgroundColor: string;
  textColor: string;
  columnIndex: number;
  columnHeader: string;
}

export interface IEventRegistrationData {
  eventid: number;
  name: string;
  email: string;
  phone: string;
  eventAppointmentId: number;
  age: number;
}
export interface IEventInfo {
  event: IEvent;
  tables: IEventTable[];
  rows: {[tableId: string]: IEventRow[]};
  columns: {[tableId: string]: IEventColumn[]};
  appointments: {[tableRowColId: string]: IEventAppointment};
}
export interface IEventRegistration {
  id: number;
  eventid: number;
  eventAppointmentId: number;
  name: string;
  email: string;
  phone: string;
  text: string;
  age: number;
}
export interface IIncomoingEventInfo {
  event: IEvent;
  tables: IEventTable[];
  rows: IEventRow[];
  columns: IEventColumn[];
  appointments: IEventAppointment[];
  registrations: IEventRegistration[];
}

export const getAppointmentId = (
  tableId: number,
  rowId: number,
  columnId: number
) => {
  return `${tableId},${rowId},${columnId}`;
};

export interface ITrialRegistration {
  id?: number;
  trial_id: number;
  name: string;
  phone: string;
  email: string;
  created_at: string;
  age: string;
}
export interface ITrialGroup {
  id: number;
  name: string;
}
export interface ITrial {
  id: number;
  trial_group_id: number;
  datetime: string;
  is_active: boolean;
  maximum_registrations: number;
  registrations: ITrainingRegistration[];
}
export interface ITrialScheduleResponse {
  trials: ITrial[];
  trial_groups: ITrialGroup[];
  excluded_days: IExcludedDay[];
}
export interface ITrialRegistrationRequest extends ITrialRegistration {}
export interface ITrialRegistrationResponse {
  success: boolean;
  trials_schedule: ITrialScheduleResponse;
}
